import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CalendarUserDistanceFilterComponent, DistanceSelectionPayload } from './calendar-user-distance-filter/calendar-user-distance-filter.component';
import { IApiUserCalendarFilter, IApiUserCalendarFilterType, IApiUserFilterType } from 'src/app/shared/modules/graphql/types/types';
import { isArray } from 'lodash';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';

@Component({
  selector: 'app-calendar-filters',
  templateUrl: './calendar-filters.component.html',
  styleUrls: ['./calendar-filters.component.scss']
})
export class CalendarFiltersComponent {

  @Input() filters: IApiUserCalendarFilter[] = [];

  @Output() clearFilter = new EventEmitter<IApiUserCalendarFilter[]>();
  @Output() applyFilter = new EventEmitter<IApiUserCalendarFilter[]>();
  @Output() distanceSelectionChange = new EventEmitter<DistanceSelectionPayload>();

  @ViewChild(CalendarUserDistanceFilterComponent) distanceFilter!: CalendarUserDistanceFilterComponent;

  public filterTypes = IApiUserCalendarFilterType;
  public userViewFilter = IApiUserFilterType.ViewStaffUser;
  public proximityAddress: string = '';
  public selectedUserIds: any[] = [];
  public selectedDistanceUserIds: any[] = [];

  public get totalSelectedCount(): number {
    const mergedIds = new Set([...(this.selectedUserIds || []), ...(this.selectedDistanceUserIds || [])]);
    return mergedIds.size;
  }

  public static readonly MAX_INVESTIGATORS = 20;
  public readonly MAX_INVESTIGATORS = CalendarFiltersComponent.MAX_INVESTIGATORS;

  constructor(private notificationsService: NotificationsService) { }

  public setUserFilters(ids: any[]): void {
    const prevCount = this.totalSelectedCount;
    this.selectedUserIds = ids || [];
    if (this.totalSelectedCount > prevCount) {
      this.checkLimit();
    }
    this.updateFilters();
  }

  public setDistanceUserFilters(ids: any[]): void {
    const prevCount = this.totalSelectedCount;
    this.selectedDistanceUserIds = ids || [];
    if (this.totalSelectedCount > prevCount) {
      this.checkLimit();
    }
    this.updateFilters();
  }

  private checkLimit(): void {
    if (this.totalSelectedCount > CalendarFiltersComponent.MAX_INVESTIGATORS) {
      this.notificationsService.alert(`You can select a maximum of ${CalendarFiltersComponent.MAX_INVESTIGATORS} investigators. Please reduce your selection to proceed.`, 'Selection Limit Exceeded').subscribe();
    }
  }

  private updateFilters(): void {
    const mergedIds = Array.from(new Set([...this.selectedUserIds, ...this.selectedDistanceUserIds]));
    this.setFilters(mergedIds, IApiUserCalendarFilterType.UserIdIn);
  }

  public onDistanceSelectionChange(payload: DistanceSelectionPayload): void {
    this.distanceSelectionChange.emit(payload);
  }

  public setFilters(value: any, type: IApiUserCalendarFilterType): void {
    const hasValue = (val: any) => (val !== undefined) && (val !== null);

    // Convert arrays of length 0 to null
    let valToSave = value;
    if (isArray(value)) {
      if (value.length === 0) {
        valToSave = null;
      } else {
        valToSave = JSON.stringify(value);
      }
    }

    const filtersCopy = this.filters.filter(f => f.type !== type);
    this.filters = hasValue(valToSave) ? [...filtersCopy, {
      type: type,
      value: valToSave
    }] : filtersCopy;
  }

  public filterValue(filterType: IApiUserCalendarFilterType) {
    const value = this.filters.find(({ type }) => type === filterType)?.value;

    if (value) {
      return value === "true" || value === "false" || isArray(value)
        ? JSON.parse(value)
        : typeof value === "string" && value
          ? value
          : null;
    }
    return null;
  }

  public filterByIdValue(filterType: IApiUserCalendarFilterType) {
    const value = this.filters.find(({ type }) => type === filterType)?.value;
    return value ? JSON.parse(value) : null;
  }

  public appliedFilters(): void {
    this.applyFilter.emit(this.filters);
  }

  public clearAll(): void {
    this.filters = [];
    this.proximityAddress = '';
    this.selectedUserIds = [];
    this.selectedDistanceUserIds = [];
    this.distanceFilter?.clear();
    this.clearFilter.emit(this.filters);
  }

}
